var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewPinterestOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2 0h4v6H5V5zm4 8H5v2h4v-2zm2-8h4v4h-4V5zm4 6h-4v4h4v-4z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDVDMyAzLjg5NTQzIDMuODk1NDMgMyA1IDNIMTVDMTYuMTA0NiAzIDE3IDMuODk1NDMgMTcgNVYxNUMxNyAxNi4xMDQ2IDE2LjEwNDYgMTcgMTUgMTdINUMzLjg5NTQzIDE3IDMgMTYuMTA0NiAzIDE1VjVaTTUgNUg5VjExSDVWNVpNOSAxM0g1VjE1SDlWMTNaTTExIDVIMTVWOUgxMVY1Wk0xNSAxMUgxMVYxNUgxNVYxMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgViewPinterestOutline20 as ReactComponent };